/**
 * angular imports
 */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
/**
 * service imports
 */
import { GetService } from 'src/app/dataservices/get.service';

@Component({
  selector: 'app-multi-select-drop-dowm',
  templateUrl: './multi-select-drop-dowm.component.html',
  styleUrls: ['./multi-select-drop-dowm.component.scss']
})
export class MultiSelectDropDowmComponent implements OnInit  {


  constructor(private getService: GetService) {
  }
  
  @Input() apiUrl: string;

  @Input() isInerrorState: boolean;

  @Input() label: string;

  @Input()  selectedValues = [];

  @Input()  placeholder: string;

  @Input() mandatory=false;
  /**
   * Used to emit the selected value.
   */
  @Output() emitSelectedValue: EventEmitter<string[]> = new EventEmitter();

  /**
   * 
   * emiting event for focus
   */
  @Output() elementTouched: EventEmitter<null> =  new EventEmitter(); 
  ngOnInit(): void {
    if (this.apiUrl) {
      this.getSearchList('');
    }
  }

  @Input() suggestionList;

  public defaultList;
  getSearchList(query = ''): any  {
    return  this.getService.getSearchDataForDropDown(this.apiUrl+ query).subscribe(data => {
      if (query.length === 0) {
        this.defaultList = data.lc;
      }
      this.suggestionList = data.lc;
     });
 }

 filterData(event): void {
  if (event.filter.length >= 3 && this.apiUrl) {
    this.getSearchList(event.filter);
  }
  else {
    this.suggestionList = this.defaultList;
  }
 }
 selectValues(event): void {
  this.emitSelectedValue.emit(this.selectedValues)
 }

 elementFocused(): void {
// 
this.elementTouched.emit();
 }
}
